import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
          <i className="ri-question-line" aria-hidden="true"></i>
          常见问题
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-900 md:text-3xl">
          关于守护甜心的常见疑问
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-foreground-600">
          刚入坑或补番的观众，这些高频问题都能在这里找到答案。
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-3">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.q}
              className="overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-colors"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="font-heading text-base font-bold text-foreground-900">{item.q}</h3>
                <span
                  className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition-transform ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                </span>
              </button>
              {isOpen && (
                <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-7 text-foreground-600">
                  {item.a}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}